function UserDelete(){
    return(
        <div className="report-box">
            회원탈퇴
        </div>
    )
}

export default UserDelete;